export var ErrorNames;
(function (ErrorNames) {
    ErrorNames["ABORT"] = "AbortError";
    ErrorNames["FETCH"] = "FetchError";
    ErrorNames["INVALID_JSON_PARSE"] = "InvalidJsonParseError";
    ErrorNames["UNRESOLVABLE_DATA"] = "UnresolvableDataError";
    ErrorNames["INVALID_STATE_MACHINE_ACTION"] = "InvalidStateMachineActionError";
})(ErrorNames || (ErrorNames = {}));
//# sourceMappingURL=ErrorNames.js.map